"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandMoreIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const ExpandMoreIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    react_1.default.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" })));
exports.ExpandMoreIcon = ExpandMoreIcon;
exports.default = exports.ExpandMoreIcon;
